import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

type Status = 'true' | 'false' | 'pending';

@Directive({
  selector: '[brnTableLoader]',
})
export class TableLoaderDirective implements OnChanges, OnInit {
  private tableBody!: any;
  private cols!: number;
  private loaderBody!: any;

  @Input()
  status!: Status;

  @Input()
  set colsNum(cols: number) {
    this.cols = cols;
    this.createLoaderBody(true);
  }

  get colsNum(): number {
    return this.cols;
  }

  constructor(private elem: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.tableBody = this.elem.nativeElement.querySelector('tbody');
    this.cols =
      this.colsNum ||
      this.elem.nativeElement.querySelector('thead>tr').children.length;

    this.createLoaderBody();
    this.onStatusChange();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.onStatusChange();
  }

  private onStatusChange(): void {
    if (!this.tableBody) {
      return;
    }
    if (this.status === 'pending') {
      this.renderer.setStyle(this.tableBody, 'visibility', 'collapse');
      this.renderer.insertBefore(
        this.elem.nativeElement,
        this.loaderBody,
        this.tableBody
      );
    } else {
      this.renderer.setStyle(this.tableBody, 'visibility', 'visible');
      this.renderer.removeChild(this.elem.nativeElement, this.loaderBody);
    }
  }

  private createLoaderBody(newRender?: boolean): void {
    if (newRender) {
      if (this.loaderBody) {
        this.renderer.removeChild(this.elem.nativeElement, this.loaderBody);
      }
    }
    this.loaderBody = this.renderer.createElement('tbody');
    for (let i = 0; i < 30; i++) {
      // generate row
      const row = this.renderer.createElement('tr');
      for (let j = 0; j < this.cols; j++) {
        // random width for placeholder (60% - 100%)
        const width = Math.floor(Math.random() * (100 - 60 + 1)) + 60;
        // generate cell with placeholder
        const cell = this.renderer.createElement('td');
        const placeholder = this.renderer.createElement('b');
        this.renderer.setStyle(placeholder, 'width', `${width}%`);
        this.renderer.appendChild(cell, placeholder);
        this.renderer.addClass(cell, 'loader-cell');
        this.renderer.appendChild(row, cell);
      }
      this.renderer.appendChild(this.loaderBody, row);
    }
  }
}
